jQuery(function ($) {
	$(".testimonials__slider").each(function () {
		var $slider = $(this);
		if ($slider.hasClass("owl-loaded")) {
			return;
		}

		// Owl silently drops loop when item count <= items shown, so the
		// carousel would stop looping at wide breakpoints. Clone until there
		// are more than the 4 shown at 1024px+.
		var MAX_VISIBLE = 4;
		var $originals = $slider.children();
		var count = $originals.length || 1;
		while ($slider.children().length <= MAX_VISIBLE) {
			$slider.append($originals.clone());
		}

		// "Scroll Speed (seconds)" = time for one full pass of all items.
		// autoplaySpeed must stay strictly under autoplayTimeout: Owl's autoplay
		// interval skips any tick that lands while a transition is still running,
		// so equal values stall the carousel after the first move.
		var seconds = parseFloat($slider.data("speed")) || 24;
		var perMove = Math.max(400, Math.round((seconds * 1000) / count));
		var moveSpeed = Math.round(perMove * 0.85);

		$slider.owlCarousel({
			loop: true,
			autoplay: true,
			autoplayTimeout: perMove,
			autoplaySpeed: moveSpeed,
			autoplayHoverPause: false,
			margin: 0,
			nav: true,
            navText: [
				'<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="visually-hidden">Previous</span>',
				'<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="visually-hidden">Next</span>',
			],
			dots: false,
			stagePadding: 40,
			responsive: {
				0: {
					items: 1,
				},
				992: {

			        stagePadding: 80,
					items: 4,
				},
			},
		});
	});
});
